import { dashboardPWTypes } from './actionTypes';

export const getFilterListPW = () => {
  return {
    type: dashboardPWTypes.GET_FILTER_LISTPW,
  };
};

export const getFilterListSuccessPW = (payload: any) => ({
  type: dashboardPWTypes.GET_FILTER_LIST_SUCCESSPW,
  payload,
});

export const getFilterListFailPW = (error: any) => ({
  type: dashboardPWTypes.GET_FILTER_LIST_FAILPW,
  payload: error,
});

export const getFilterDataPW = (payload: any) => ({
  type: dashboardPWTypes.GET_FILTER_DATAPW,
  payload,
});

export const getFilterDataSuccessPW = (payload: any) => ({
  type: dashboardPWTypes.GET_FILTER_DATA_SUCCESSPW,
  payload,
});

export const getFilterDataFailPW = (error: any) => ({
  type: dashboardPWTypes.GET_FILTER_DATA_FAILPW,
  payload: error,
});
